import colorTokens from '@/styles/colorTokens'

interface CSSVariableProps {
  [key: string]: string
}

function colorTokensToCSSVariables() {
  const commonVariables: CSSVariableProps = {}
  const darkThemeVariables: CSSVariableProps = {}
  const lightThemeVariables: CSSVariableProps = {}

  Object.entries(colorTokens).forEach(([colorScope, tokenColorMapping]) => {
    Object.entries(tokenColorMapping).forEach(([token, color]) => {
      // Transform token '{ bg: { surface2Dark: ... } } to variable name '--bg-surface-2''
      const variableNameArr = token.split(/(?=[0-9A-Z])/).map(s => s.toLowerCase())
      const suffix = variableNameArr[variableNameArr.length - 1]
      let variableName = ''

      if (suffix === 'dark' || suffix === 'light') {
        variableName = `--${colorScope}-${variableNameArr.slice(0, variableNameArr.length - 1).join('-')}`
        if (suffix === 'dark') {
          darkThemeVariables[variableName] = color as string
        } else {
          lightThemeVariables[variableName] = color as string
        }
      } else {
        variableName = `--${colorScope}-${variableNameArr.join('-')}`
        commonVariables[variableName] = color as string
      }
    })
  })
  return { commonVariables, darkThemeVariables, lightThemeVariables }
}

export default colorTokensToCSSVariables()
